import React, { Component } from 'react';
import { Button, Form, Input, Modal, Table } from 'antd';

import { queryDeleteAttachment } from '@api/pub/attachment';
import UploadFile from '@comm/upload/UploadFileTable';
import { Link } from 'react-router';

const FormItem = Form.Item;

class ModalAccount extends Component {
  state = {
    renewalFiles: [],
    renewalFilesCount: 0,
  };

  componentDidMount() {
    const { renewalFiles } = this.props;
    if (renewalFiles && renewalFiles.length) {
      renewalFiles.map(item => {
        item.id = item.uuid;
        return 1;
      });
      this.setState({
        renewalFiles,
        renewalFilesCount: renewalFiles.length,
      });
    }
  }

  handleOk = () => {
    const { renewalFiles } = this.props;
    const newRenewalFiles = [];
    this.props.form.validateFields((err, values) => {
      if (!err) {
        renewalFiles.map(item => {
          item.scans = values[`scans${item.uuid || item.id}`];
          newRenewalFiles.push({
            uuid: item.uuid,
            name: values[`name${item.uuid || item.id}`],
            scans: item.scans,
          });

          if (item.delFiles && item.delFiles.length > 0) {
            item.delFiles.map(i => {
              queryDeleteAttachment({
                uuid: i.uuid || i.uid,
              }).then(() => {});
              return i;
            });
          }
          return item;
        });

        this.props.handleOk({ renewalFiles: newRenewalFiles });
      }
    });
  };

  deleteEffects = id => {
    const { renewalFiles } = this.state;
    this.setState({
      renewalFiles: renewalFiles.filter(item => item.id !== id),
    });
  };

  addEffects = () => {
    const { renewalFiles, renewalFilesCount } = this.state;
    renewalFiles.push({ id: renewalFilesCount });
    this.setState({
      renewalFiles,
      renewalFilesCount: renewalFilesCount + 1,
    });
  };

  /**
   *文件删除
   */
  fileRemove = (item, file) => {
    item.delFiles.push(file);
  };

  scansColumns = () => {
    const { getFieldDecorator } = this.props.form;
    return [
      {
        title: '文件名称',
        dataIndex: 'name',
        key: 'name',
        width: '50%',
        render: (text, record) => {
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`name${record.uuid || record.id}`, {
                rules: [{ required: !record.uuid, message: '请填写文件名称' }],
              })(!record.uuid ? <Input /> : <span>{record.name || '暂无名称'}</span>)}
            </FormItem>
          );
        },
      },
      {
        title: '扫描件',
        dataIndex: 'scans',
        key: 'scans',
        width: '50%',
        render: (text, record) => {
          return (
            <FormItem>
              {getFieldDecorator(`scans${record.uuid || record.id}`, {
                rules: [{ required: record.isReturn, message: '请上传扫描件' }],
                initialValue: record.scans,
              })(
                <UploadFile
                  type="ghost"
                  fileList={record.file}
                  onRemove={file => this.fileRemove(record, file)}
                  isPreview
                />,
              )}
            </FormItem>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: '50%',
        render: (text, record) => {
          return (
            !record.uuid && (
              <div style={{ margin: 0, height: '45px' }}>
                <Link onClick={() => this.deleteEffects(record.id)}>删除</Link>
              </div>
            )
          );
        },
      },
    ];
  };

  render() {
    const { visible, handleCancel, confirmLoading } = this.props;
    const { renewalFiles } = this.state;
    return (
      <Modal
        title="上传扫描件（用章后）"
        visible={visible}
        onOk={this.handleOk}
        okText="通过"
        confirmLoading={confirmLoading}
        onCancel={() => handleCancel(false)}
        width="40%"
      >
        <Form>
          <Table
            columns={this.scansColumns()}
            dataSource={renewalFiles}
            pagination={false}
            rowKey={record => record.uuid}
          />
          <Button onClick={this.addEffects} style={{ width: '100%', borderStyle: 'dashed' }}>
            +添加附件
          </Button>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(ModalAccount);



// WEBPACK FOOTER //
// ./src/components/comm/workflow/renewal/ModalScanUpload.js